var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`style-${_vm.grid.style}`},[_c('div',{class:_vm.gridClasses},_vm._l((_vm.grid.items),function(item){return _c('Item',{key:`item-${item.id}`,attrs:{"item":item}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }